(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ts-promoted-products-carousel"] && !Shopify.designMode) return;
  try {
    /**
   * Keeps the carousel arrows on the slide image's vertical midline by
   * measuring the first slide's media and exposing it as --ts-arrows-top
   * on the slideshow container (consumed by the arrows overlay CSS).
   */
  class TsPromotedProductsCarousel extends HTMLElement {
    /** @type {ResizeObserver | null} */
    #resizeObserver = null;

    connectedCallback() {
      const media = this.querySelector(
        '.ts-promoted-products-featured-product__media, .ts-promoted-products-featured-product__grid'
      );
      const container = this.querySelector('slideshow-container');
      if (!(media instanceof HTMLElement) || !(container instanceof HTMLElement)) return;

      this.#resizeObserver = new ResizeObserver(() => positionArrows(media, container));
      this.#resizeObserver.observe(media);
      this.#resizeObserver.observe(container);
    }

    disconnectedCallback() {
      this.#resizeObserver?.disconnect();
    }
  }

  /**
   * @param {HTMLElement} media - The first slide's media element
   * @param {HTMLElement} container - The slideshow container the arrows overlay
   */
  const positionArrows = (media, container) => {
    const mediaRect = media.getBoundingClientRect();
    const containerRect = container.getBoundingClientRect();
    const center = mediaRect.top - containerRect.top + mediaRect.height / 2;

    container.style.setProperty('--ts-arrows-top', `${center}px`);
  };

  customElements.define('ts-promoted-products-carousel', TsPromotedProductsCarousel);
  } catch(e) { console.error(e); }
})();

})();
